import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

const SESSION_KEY = 'customer_synced'

// Runs at the root level (wrapRootElement) so it fires on every page,
// not just /account. Calls POST /account/sync once per login session.
// sessionStorage is cleared on tab close, so a new session always re-syncs.
// In Shopify mode the endpoint is a no-op, so no guard needed here.
export const CustomerSyncProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth0()

  useEffect(() => {
    if (!isAuthenticated || !user?.email) return
    const key = `${SESSION_KEY}:${user.email}`
    if (sessionStorage.getItem(key)) return
    sessionStorage.setItem(key, '1')

    fetch(`${process.env.GATSBY_WORKER_DOMAIN}/account/sync`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: user.email }),
    }).catch((err) => {
      // Roll back so it retries on next render if the request failed
      sessionStorage.removeItem(key)
      console.error('CustomerSync error:', err)
    })
  }, [isAuthenticated, user?.email])

  return <>{children}</>
}
